var EntryKinds = /* @__PURE__ */ ((EntryKinds2) => {
  EntryKinds2["INPUT"] = "input";
  EntryKinds2["LEGACY_CANVAS_SHAPE"] = "legacyCanvasShape";
  EntryKinds2["TABLE"] = "table";
  return EntryKinds2;
})(EntryKinds || {});

export { EntryKinds };
//# sourceMappingURL=IEntry.js.map
